module.exports = __webpack_public_path__ + "img/2868619.png";